import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { LanguageConstants } from "../../constants/LanguageConstants";
import { QUOTE_SUCCESS_LOGO_URL } from "../../utils/quoteSuccessLogo";
import "./OrderSuccess.scss";

type OrderSuccessOverlayProps = {
  show: boolean;
  /** Wire-transfer confirmation copy (vs card/online success). */
  isWireTransfer?: boolean;
  onHome?: () => void;
};

/**
 * Order-placed confirmation as a modal overlay (checkout stays underneath).
 * Used after wire transfer; Stripe return still uses the /success route.
 */
function OrderSuccessOverlay({
  show,
  isWireTransfer = false,
  onHome,
}: OrderSuccessOverlayProps) {
  const navigate = useNavigate();

  const wireSuccessDescription =
    LanguageConstants?.ORDER_SUCCESS_WIRE_DESC ??
    "An email has been sent with the information to make the payment via wire transfer. Once we receive the funds we will proceed with your order.";
  const successDescription = isWireTransfer
    ? wireSuccessDescription
    : LanguageConstants?.ORDER_SUCCESS_DESC;

  const handleHome = () => {
    if (onHome) {
      onHome();
      return;
    }
    navigate("/");
  };

  useEffect(() => {
    if (!show) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = prev;
    };
  }, [show]);

  if (!show) return null;

  return (
    <div
      className="order-success-overlay"
      role="dialog"
      aria-modal="true"
      aria-labelledby="order-success-title"
    >
      <div className="order-success-overlay__backdrop" aria-hidden />
      <div className="order-success-overlay__panel order-success-page__card">
        <img
          src={QUOTE_SUCCESS_LOGO_URL}
          alt="Quote N Buy"
          className="order-success-page__logo"
          width={128}
          height={128}
          decoding="async"
        />
        <h1 className="order-success-page__title" id="order-success-title">
          {LanguageConstants?.ORDER_SUCCESS_TITLE}
        </h1>
        <p className="order-success-page__desc">{successDescription}</p>
        <div className="order-success-page__actions">
          <button
            type="button"
            className="order-success-page__homeBtn"
            onClick={handleHome}
          >
            {LanguageConstants?.HOME}
          </button>
        </div>
      </div>
    </div>
  );
}

export default OrderSuccessOverlay;
